module.exports = __webpack_public_path__ + "static/img/epidemic-7.6b1f143.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/epidemic-7.png
// module id = Twyw
// module chunks = 1